export enum GameMessageType {
  GO = 'go',
  SUCCESS = 'success',
  CORRECT = 'correct',
  INCORRECT = 'incorrect',
  TIME_OUT = 'time-out',
}
